import { useContext } from 'react';
import { Card, Descriptions } from 'antd';
import { Bar } from 'react-chartjs-2';
import { PageContext } from '../../../lib/context';
import { useBarcode } from 'react-barcodes';
import moment from 'moment';

const BillsInformation = () => {
  const {
    graphData,
    settingsInfo,
    rateInfo,
    info,
    meterInfo,
    billingInfo,
    subs_id,
  } = useContext(PageContext);
  const { inputRef } = useBarcode({
    value: 'react-barcodes',
    options: {
      background: '#ffffff',
      width: 1,
      height: 40,
    },
  });

  return (
    <div>
      <div className="box-border border-2 border-indigo-500 flex flex-col text-sm">
        <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
          CONSUMER INFORMATION
        </div>
        <div className="flex flex-row">
          <div className="mr-8 ml-8 mt-3 w-2/4">
            <Descriptions>
              <Descriptions.Item>{`${info?.last_name}, ${info?.first_name} `}</Descriptions.Item>
            </Descriptions>
            <Descriptions.Item>{`${info?.complete_address}`}</Descriptions.Item>
          </div>
          <div className="mr-8 ml-8 mt-3">
            <div className="mb-1">Account Code: {subs_id(info.id)}</div>
            <div className="mb-1">Consumer Type: {`${rateInfo?.name}`}</div>
            <div className="mb-1">Zip Code: {`${info?.zip_code}`}</div>
            <div className="mb-3">
              Billing Statement:{' '}
              {billingInfo?.id ? subs_id(billingInfo.id) : '---'}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row mt-1">
        <div className="mr-1 w-2/4 box-border border-2 border-indigo-500">
          <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
            METER INFORMATION
          </div>
          <div className="flex flex-row">
            <div className="mr-8 ml-8 mt-3 w-2/6">
              <div className="mb-2">Brand: {`${meterInfo?.brand}`}</div>
              <div className="mb-2">Model: {`${meterInfo?.model}`}</div>
              <div className="mb-3">
                Serial No: {`${meterInfo?.serial_number}`}
              </div>
            </div>
            <div className="mr-8 ml-8 mt-3">
              <div className="mb-1">
                Due Date: {moment(`${settingsInfo?.deadline}`).format('LL')}
              </div>
              <div className="mb-1">
                Period From:{' '}
                {billingInfo?.previous_reading_date
                  ? moment(billingInfo?.previous_reading_date).format('LL')
                  : '---'}
              </div>
              <div className="mb-1">
                Period To:{' '}
                {billingInfo?.current_reading_date
                  ? moment(billingInfo?.current_reading_date).format('LL')
                  : '---'}
              </div>
            </div>
          </div>
          <div className="flex flex-row-3 text-center mt-8">
            <div className="mr-8 ml-8 mt-3 w-2/6">
              <div className="mb-2">
                Date:
                <br />
                {billingInfo?.current_reading_date
                  ? moment(`${billingInfo?.current_reading_date}`).format('LL')
                  : '---'}
                <br />
              </div>
            </div>
            <div className="mr-8 ml-8 mt-3">
              <div className="mb-1">
                Reading:
                <br />
                {billingInfo?.current_reading
                  ? `${Math.round(billingInfo?.current_reading * 100) / 100}`
                  : '---'}
                <br />
              </div>
            </div>
            <div className="mr-8 ml-8 mt-3">
              <div className="mb-1">
                Consumption:
                <br />
                {billingInfo?.consumption
                  ? `${Math.round(billingInfo?.consumption * 100) / 100}`
                  : '---'}
              </div>
            </div>
          </div>
          <Card
            style={{
              borderRadius: 10,
              height: 300,
              width: 300,
              marginLeft: 80,
              marginBottom: 20,
              marginTop: 10,
            }}
          >
            <Bar height={100} width={100} data={graphData} type="line" />
          </Card>
        </div>
        <div className="box-border border-2 border-indigo-500 w-2/4">
          <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
            BILLING DETAILS
          </div>
          <div className="flex flex-row place-items-center mb-10">
            <div className="mr-8 ml-8 mt-3 flex flex-col-3 mb-3">
              <div className="mr-8 ml-5 text-left">
                <h1 className="">Charges</h1>
                <div>WATER FEE</div>
                <div>TAX</div>
              </div>
              <div className="mr-8 ml-9 text-center">
                <h1>Period</h1>
                <div>
                  {billingInfo?.billing_date
                    ? moment(billingInfo?.billing_date).format('LL')
                    : '---'}
                </div>
                <div>
                  {billingInfo?.billing_date
                    ? moment(billingInfo?.billing_date).format('LL')
                    : '---'}
                </div>
              </div>
              <div className="ml-9 text-right">
                <h1>Amount</h1>
                <div>
                  {billingInfo?.water_fee
                    ? `${Math.round(billingInfo?.water_fee * 100) / 100}`
                    : 0}
                </div>
                <div>
                  {billingInfo?.taxes
                    ? `${Math.round(billingInfo?.taxes * 100) / 100}`
                    : 0}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row mb-3">
            <div className="mr-8 ml-6 mb-12 flex flex-col-2 grid grid-cols-2 divide-x">
              <div className="mr-8">
                <div className="mb-1">Gross Current Bill</div>
                <div className="mb-1">Previous Balances</div>
                <div className="mb-1">Advance Payment</div>
                <div className="mb-1">Discount on Advance</div>
                <div className="mb-1">Payment</div>
              </div>
              <div className="ml-9 text-right">
                <div className="mb-1">
                  {billingInfo?.gross_current_bill
                    ? `${
                        Math.round(billingInfo?.gross_current_bill * 100) / 100
                      }`
                    : 0}
                </div>
                <div className="mb-1">
                  {billingInfo?.previous_balance
                    ? `${Math.round(billingInfo?.previous_balance * 100) / 100}`
                    : 0}
                </div>
                <div className="mb-1">
                  {billingInfo?.advance_payment
                    ? `${Math.round(billingInfo?.advance_payment * 100) / 100}`
                    : 0}
                </div>
                <div className="mb-1">
                  {billingInfo?.discount_on_advance_payment
                    ? `${
                        Math.round(
                          billingInfo?.discount_on_advance_payment * 100
                        ) / 100
                      }`
                    : 0}
                </div>
                <div className="mb-1">
                  {billingInfo?.payments_aggregate?.aggregate?.sum?.amount
                    ? `${
                        Math.round(
                          billingInfo?.payments_aggregate?.aggregate?.sum
                            ?.amount * 100
                        ) / 100
                      }`
                    : 0}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-row mb-10 grid grid-col">
            <div className="mr-8 ml-6 flex flex-col-2 grid grid-cols-2 divide-x">
              <div className="mr-8 text-center">
                <div className="mb-2">Total Amount Due</div>
                <div className="mb-2">Current Bill Period</div>
              </div>
              <div className="ml-9 mb-8 text-right">
                <div className="mb-2">
                  {billingInfo?.total_balance
                    ? `${Math.round(billingInfo?.total_balance * 100) / 100}`
                    : 0}
                </div>
                <div className="mb-2">
                  {billingInfo?.current_reading_date
                    ? moment(billingInfo?.current_reading_date).format('LL')
                    : '---'}
                </div>
              </div>
            </div>
          </div>

          <div className="text-xs mr-8 ml-6 mb-3 mt-32">
            <div>
              *Please pay on or before due date{' '}
              {settingsInfo?.deadline
                ? moment(`${settingsInfo?.deadline}`).format('LL')
                : '---'}
            </div>
          </div>
        </div>
      </div>

      <div className="box-border border-2 border-indigo-500 flex flex-col text-sm mt-1">
        <div className="box-border border-b-2 border-indigo-500 w-500 mt-12"></div>
        <div className="flex flex-col">
          <div className="mr-8 ml-8 mt-3">
            <div className="mb-2">
              <p className="text-justify text-xs">
                BE MINDFUL OF YOUR WATER BILLS. DON'T WAIT FOR YOUR MONTHLY
                WATER BILL JUST TO KNOW LEAKS IN YOUR PIPELINES. MONITOR
                FREQUENTLY YOUR METER READING. IF CONSUMPTION SUDDENLY SHOOTS UP
                COMPARED TO YOUR USUAL DAILY CONSUMPTION, YOUR WATER LINES COULD
                HAVE LEAKS. CONTINUOUS TURNING OF WATER METER DEAL EVEN IF ALL
                YOUR FAUCETS/ VALVES ARE CLOSED IS ALSO AN INDICATION OF LEAK.
                WATER LOST DUE TO LEAKS ARE DEEMED CONSUMED BY THE CONSUMER.
              </p>
            </div>
            <div className="flex flex-row-reverse mb-5 mt-16">
              <div className="grid grid-cols-2">
                <div className="border-t-2 text-center border-indigo-500">
                  Bill Distributor
                </div>
                <div className="ml-12 mr-8">
                  <div className="border-t-2 text-center border-indigo-500 w-32">
                    Date
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="box-border border-2 border-indigo-500 flex flex-col text-sm mt-1">
        <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
          PAYMENT STUB
        </div>
        <div className="flex flex-col">
          <div className="mr-8 ml-8 mt-3">
            <div className="flex flex-row">
              <div className="mr-32 mt-3 mb-1 w-2/4">
                <div>{`${info?.last_name}, ${info?.first_name}`}</div>
                <div>{`${info?.complete_address}`}</div>
              </div>
              <div className="ml-20">
                <svg ref={inputRef} />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="mr-8 ml-8 mb-3 text-xs flex flex-cols-2">
            <div className="flex flex-col-2 grid grid-cols-2 divide-x w-max">
              <div>
                <div>Zip Code</div>
                <div>Current Bill</div>
                <div>Previous Bill</div>
                <div>Total Amount Due</div>
                <div>Advance Payment</div>
              </div>
              <div className="ml-9 text-right">
                <div>{`${info.zip_code}`}</div>
                <div>
                  {billingInfo?.gross_current_bill
                    ? `${billingInfo?.gross_current_bill}`
                    : 0}
                </div>
                <div>
                  {billingInfo?.previous_balance
                    ? `${billingInfo?.previous_balance}`
                    : 0}
                </div>
                <div>
                  {billingInfo?.total_balance
                    ? `${Math.round(billingInfo?.total_balance * 100) / 100}`
                    : 0}
                </div>
                <div>
                  {billingInfo?.advance_payment
                    ? `${Math.round(billingInfo?.advance_payment * 100) / 100}`
                    : 0}
                </div>
              </div>
            </div>
            <div className="flex flex-col-2 grid grid-cols-2 divide-x">
              <div className="ml-14">
                <div>Account Code</div>
                <div>Due Date</div>
                <div>Billing Statement</div>
              </div>
              <div className="ml-9 text-right">
                <div>{subs_id(info.id)}</div>
                <div>
                  {settingsInfo?.deadline
                    ? moment(`${settingsInfo?.deadline}`).format('LL')
                    : '---'}
                </div>
                <div>{billingInfo?.id ? subs_id(billingInfo.id) : '---'}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="box-border border-t-2 border-indigo-500 w-500">
          <div className="mr-8 ml-8 mt-3 mb-3">
            <p className="text-indigo-700 font-normal italic text-justify">
              Please make checks payable to{' '}
              <a className="underline font-semibold">
                Metropolitan Cebu Water District
              </a>{' '}
              . Indicate your Name, Consumer Code, Telephone Numbers and
              Signature at the back of the check.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillsInformation;
